var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1 ml-2 text-sm text-green-600"},[_vm._v(_vm._s(_vm.$t('text.new')))])}
var staticRenderFns = []

export { render, staticRenderFns }